// @ is an alias to /src
import mastertime from '@/api/mastertime'

export const namespaced = true

export const state = {
  announcements: [],
}

export const mutations = {
  setAnnouncements(state, announcements) {
    state.announcements = announcements
  },

  addAnnouncement(state, announcement) {
    state.announcements.push(announcement)
  },

  editAnnouncement(state, announcement) {
    const index = state.announcements.findIndex(
      (el) =>
        el.system_announcement_uuid === announcement.system_announcement_uuid
    )
    if (index !== -1) {
      state.announcements.splice(index, 1, announcement)
    }
  },

  deleteAnnouncement(state, system_announcement_uuid) {
    const index = state.announcements.findIndex(
      (el) => el.system_announcement_uuid === system_announcement_uuid
    )
    if (index !== -1) {
      state.announcements.splice(index, 1)
    }
  },
}

export const actions = {
  async fetchAnnouncements({ commit }) {
    const { data } = await mastertime.fetchAnnouncements()
    const announcements = data.data

    commit('setAnnouncements', announcements)
  },

  async addAnnouncement({ commit }, announcement) {
    const { data } = await mastertime.addAnnouncement(announcement)

    commit('addAnnouncement', data)
    return data
  },

  async editAnnouncement({ commit }, announcement) {
    const { data } = await mastertime.editAnnouncement(announcement)

    commit('editAnnouncement', data)
  },

  async deleteAnnouncement({ commit }, system_announcement_uuid) {
    await mastertime.deleteAnnouncement(system_announcement_uuid)

    commit('deleteAnnouncement', system_announcement_uuid)
  },

  async sendAnnouncement(_, payload) {
    await mastertime.sendAnnouncement(payload)
  },
}
